import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBTextField, DBIntField, DBCheckBox, RedoButton, StatusGood } from '_components';
import styles from './Common.module.css';
import { codeValidForAdmit } from '_helpers';
import { ModDBDropDown } from './ModDBDropDown';


class AlModRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLMODALITIES', 'XLMD', this.props.mod.XLMDNO);
    }

    componentDidUpdate() {
        if (this.props.mod.XLMDPENDING === null && !this.props.trtValid) {
            this.props.updateBitField(this.props.noteId, 'MLMODALITIES', 'XLMDNO', this.props.mod.XLMDNO, 'XLMDPENDING', true);
        }
    }

    handleChange(event) {
        if (event.target.value === "-1" || parseInt(event.target.value) !== this.props.mod.XLMDMDNO) {
            this.props.clearField(this.props.noteId, 'MLMODALITIES', 'XLMDNO', this.props.mod.XLMDNO, 'XLMDPENDING');
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    confirmPending() {
        this.props.updateBitField(this.props.noteId, 'MLMODALITIES', 'XLMDNO', this.props.mod.XLMDNO, 'XLMDPENDING', false);
    }

    handlePerformed(val) {
        if (val && !this.props.onPlan && this.props.mod.XLMDMDNO) {
            this.props.addPlanSubCat(this.props.noteId, this.props.plno, this.props.mod.XLMDMDNO, this.props.timed, undefined);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    handleTimeChange() {
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.mod.XLMDPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <ModDBDropDown
                            field='XLMDMDNO'
                            noteId={this.props.noteId}
                            entity='MLMODALITIES'
                            entityKeyColumn='XLMDNO'
                            entityKeyValue={this.props.mod.XLMDNO}
                            className={this.props.mod.XLMDPERFORMED && !this.props.mod.XLMDMDNO ? styles.col1_performed : styles.col1}
                            customOptions={this.props.activities}
                            onChange={(event) => this.handleChange(event)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLMODALITIES'
                            entityKeyColumn='XLMDNO'
                            entityKeyValue={this.props.mod.XLMDNO}
                            field='XLMDACTIVITY'
                            className={this.props.mod.XLMDPERFORMED && !this.props.mod.XLMDACTIVITY ? styles.col2_wide_performed : styles.col2_wide}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBIntField
                            noteId={this.props.noteId}
                            entity='MLMODALITIES'
                            entityKeyColumn='XLMDNO'
                            entityKeyValue={this.props.mod.XLMDNO}
                            field='XLMDTIME'
                            min={0}
                            className={this.props.mod.XLMDPERFORMED && !this.props.mod.XLMDTIME ? styles.col3_narrow_performed : styles.col3_narrow}
                            onClick={() => this.handleTimeChange()}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLMODALITIES'
                            entityKeyColumn='XLMDNO'
                            entityKeyValue={this.props.mod.XLMDNO}
                            field='XLMDPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    {this.props.assistVisible &&
                        <div className={styles.cell_wrapper}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='MLMODALITIES'
                                entityKeyColumn='XLMDNO'
                                entityKeyValue={this.props.mod.XLMDNO}
                                field='XLMDASSIST'
                                className={styles.col5}
                            />
                        </div>
                    }
                    {!this.props.assistVisible &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col5} />
                        </div>
                    }
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
                {this.props.mod.XLMDPENDING &&
                    <div className={styles.row}>
                        <span className={styles.button_spacer} />
                        <span className={styles.warning_msg}>This treatment code is not covered by the patient's payer and will <b>not</b> be reimbursed.  Do you wish to add it anyway?</span>
                        <span className={styles.yes_button} >
                            <StatusGood size='extra-small' title='Yes' onClick={() => this.confirmPending()} />
                        </span>
                        <span className={styles.no_button} >
                            <CancelButton size='extra-small' title='No' onClick={() => this.remove()} />
                        </span>
                    </div>
                }
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        addPlanSubCat: bindActionCreators(noteActions.addPlanSubCat, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let mod = state.entities.notes.MLMODALITIES[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLMODALITIESPREV)
        .find(key => (state.entities.notes.MLMODALITIESPREV[key].NoteId === noteId &&
            state.entities.notes.MLMODALITIESPREV[key].XLMDMDNO === mod.XLMDMDNO &&
            state.entities.notes.MLMODALITIESPREV[key].XLMDACTIVITY === mod.XLMDACTIVITY
        )) !== undefined ? true : false;
    let code = undefined;
    let timed = undefined;
    let onPlan = false;
    let assistVisible = state.entities.admissions[epno].contractTracksAssistant;
    let trtValid = true;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    if (mod.XLMDMDNO !== null) {
        code = state.entities.masterData.MLMASTERMODALITIES[
            Object.keys(state.entities.masterData.MLMASTERMODALITIES)
                .find(key => (state.entities.masterData.MLMASTERMODALITIES[key].MDNO === mod.XLMDMDNO))
        ].MDCODE;
        trtValid = codeValidForAdmit(epno, code);
        timed = state.entities.masterData.MLMASTERMODALITIES[
            Object.keys(state.entities.masterData.MLMASTERMODALITIES)
                .find(key => (state.entities.masterData.MLMASTERMODALITIES[key].MDNO === mod.XLMDMDNO))
        ].MDTIMED;

        onPlan =
            (
                (state.entities.notes.PTPLANTIMEDMODALITIES && Object.keys(state.entities.notes.PTPLANTIMEDMODALITIES)
                    .find(key => (state.entities.notes.PTPLANTIMEDMODALITIES[key].TMPLNO === plno &&
                        state.entities.notes.PTPLANTIMEDMODALITIES[key].TMMDNO === mod.XLMDMDNO)) ? true : false)
                ||
                (state.entities.notes.PTPLANUNTIMEDMODALITIES && Object.keys(state.entities.notes.PTPLANUNTIMEDMODALITIES)
                    .find(key => (state.entities.notes.PTPLANUNTIMEDMODALITIES[key].UMPLNO === plno &&
                        state.entities.notes.PTPLANUNTIMEDMODALITIES[key].UMMDNO === mod.XLMDMDNO)) ? true : false)
            );
    }

    let activities = state.entities.masterData.MLMASTERMODALITIES ?
        Object.keys(state.entities.masterData.MLMASTERMODALITIES)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERMODALITIES[key].MDPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTERMODALITIES[key].MDMC) ||
                    (isWc && state.entities.masterData.MLMASTERMODALITIES[key].MDWC) ||
                    (isAuto && state.entities.masterData.MLMASTERMODALITIES[key].MDAUTO) ||
                    (isOther && state.entities.masterData.MLMASTERMODALITIES[key].MDOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERMODALITIES[a].MDNAME.localeCompare(state.entities.masterData.MLMASTERMODALITIES[b].MDNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERMODALITIES[key].MDNO,
                    value: state.entities.masterData.MLMASTERMODALITIES[key].MDNAME + ' - ' + state.entities.masterData.MLMASTERMODALITIES[key].MDCODE,
                    timed: state.entities.masterData.MLMASTERMODALITIES[key].MDTIMED
                }
            )) : [];
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        mod: mod,
        activities: activities,
        trtValid: trtValid,
        prevVisit: prevVisit,
        assistVisible: assistVisible,
        plno,
        timed,
        onPlan,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlModRow = connect(mapStateToProps, mapDispatchToProps)(AlModRow);
export { connectedAlModRow as AlModRow };

